/**
 * Google Analytics 4 (etiqueta gtag.js). Es el snippet de Google pasado a módulo porque la CSP de
 * nginx no admite scripts inline. Solo carga con el consentimiento de cookies
 * (`features/cookies/consent.ts`). Las vistas de la SPA las cuenta GA con la medición mejorada
 * ("cambios de página según el historial del navegador"), sin código extra.
 */
const GA_ID = 'G-FHM9BFH8W2';

let loaded = false;

/** Solo en producción y fuera de la máquina local: las pruebas e2e corren el build en 127.0.0.1. */
export function analyticsAvailable(): boolean {
  return import.meta.env.PROD && !['127.0.0.1', 'localhost'].includes(window.location.hostname);
}

export function loadAnalytics(): void {
  if (loaded || !analyticsAvailable()) return;
  loaded = true;
  const w = window as unknown as { dataLayer: unknown[]; gtag: (...args: unknown[]) => void };
  w.dataLayer = w.dataLayer || [];
  // gtag.js espera el objeto `arguments`, no un arreglo.
  w.gtag = function gtag() {
    w.dataLayer.push(arguments);
  };
  w.gtag('js', new Date());
  w.gtag('config', GA_ID);

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
}

/**
 * Evento de conversión. Sin consentimiento (o en local) gtag no existe y no se envía nada. Los
 * nombres los lee el comité en GA4: `sign_up`, `visita_estacion`, `calificacion` y
 * `pasaporte_descargado`.
 */
export function trackEvent(name: string, params?: Record<string, string | number>): void {
  const gtag = (window as unknown as { gtag?: (...args: unknown[]) => void }).gtag;
  gtag?.('event', name, params);
}
